














































































import mixins from 'vue-typed-mixins'
import Badge from '@/components/Badge.vue'
import Spinner from '@/components/Spinner.vue'
import PullRefresh from '@/components/PullRefresh.vue'
import ScrollMixin from '@/mixins/ScrollMixin'
import VirtualScrollMixin from '@/mixins/VirtualScrollMixin'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import { versionCompare, sleep } from '@/utils/helpers'

export default mixins(ScrollMixin, VirtualScrollMixin).extend({
  name: 'Message',
  components: {
    Badge,
    PullRefresh,
    Spinner
  },
  data() {
    return {
      initialized: false,
      fetchPayload: {
        url: '/message_list/',
        params: {
          page: 'get_init'
        }
      },
      isEditingMode: false,
      isLoading: false,
      fetching: false,
      refreshing: false,
      selectedIds: [],
      selectedIdsNum: 0
    }
  },
  computed: {
    ...mapGetters('MessageList', ['entries', 'enabledInfinite', 'distance']),

    itemSize(): number {
      return 96
    },

    isEmptyEntries(): boolean {
      return this.initialized && this.$store.getters['MessageList/entries'].length === 0
    },

    disabledRemoveButton(): boolean {
      return this.selectedIdsNum === 0
    }
  },
  created(this: any) {
    this.fetchPayload.params['p'] = 0
    if (this.entries.length === 0) {
      // 0件ならの処理を beforeRouteEnter で実行すると無限スクロール中に onRefresh するとトークが空になる
      this.fetchData()
    }

    this.$root.$on('routerViewKeyChange', this.resetData)
  },
  async mounted() {
    await this.$nextTick()

    this.$_restoreSavedPosition('MessageList')

    if (window.pageYOffset === 0) {
      this.fetchData()
    }

    // window に無限スクロールをセット
    this.$_setHandleScroll(1000, this.handleInfinite)

    this.$_restoreScrollY()

    await sleep(1000)
    this.initialized = true
  },
  destroyed(this: any) {
    this.$root.$off('routerViewKeyChange', this.resetData)
  },
  methods: {
    ...mapMutations('MessageList', [
      'clearEntries',
      'removeEntry',
      'setHasMessageBadge',
      'setSavedPosition'
    ]),
    ...mapActions('MessageList', ['getEntries', 'infinite']),

    /**
     * サーバからデータを取得
     */
    async fetchData(this: any) {
      if (this.fetching) return
      this.fetching = true

      const data = await this.getEntries(this.fetchPayload)
      this.setHasMessageBadge(data && data.has_unread)

      this.fetching = false
    },

    /**
     * entries を空にすることをトリガーにしてデータをリセットする
     */
    resetData(this: any) {
      this.clearEntries()
    },

    /**
     * .media をクリック
     */
    handleMediaClick(item: any, index: number) {
      if (this.isEditingMode) {
        if (this.selectedIds[index]) {
          this.$set(this.selectedIds, index, '')
          this.selectedIdsNum -= 1
        } else {
          this.selectedIdsNum += 1
          this.$set(this.selectedIds, index, item.id)
        }
      } else {
        this.jumpToChat(item, index)
      }
    },

    /**
     * b-checkbox の値が変わると呼び出させる
     */
    handleBCheckboxInput(val) {
      if (val) {
        this.selectedIdsNum += 1
      } else {
        this.selectedIdsNum -= 1
      }
    },

    /**
     * チャットページにジャンプ
     */
    jumpToChat(item: any, key: number) {
      this.$store.commit(`${this.$store.getters.fromStoreModuleName}/setCurrentEntryKey`, key)
      this.$store.commit('MessageList/setCurrentEntryKey', key)
      this.$store.commit('Chat/setName', item.name)
      this.$store.commit('Chat/setImageUrl', item.profile_image_url)
      this.$router.push({ name: 'chat', params: { id: item.id, key: key + '' } })
    },

    /**
     * 編集モードをトグル
     */
    toggleEditMode() {
      this.isEditingMode = !this.isEditingMode
    },

    /**
     * 全ての未読メッセージを既読に
     */
    async handleAllAlreadyReadClick() {
      const buttonIndex = await this.$_confirm('全てのメッセージを既読にしますか？', '', [
        'キャンセル',
        '全て既読にする'
      ])
      if (!this.$_clickedConfirmOK(buttonIndex)) {
        return
      }

      const data = await this.$store.dispatch('MessageList/allAlreadyReadSelectedUsers')
      if (data.error) {
        this.$_alert('メッセージ既読に失敗')
        console.error(data)
      }
      this.selectedIds = []
      this.toggleEditMode()
      this.onRefresh()
    },

    /**
     * 選択したメッセージを削除
     */
    async handleRemoveSelectedClick() {
      const buttonIndex = await this.$_confirm(
        '選択したユーザーとの全てのメッセージを削除にしますか？',
        '',
        ['キャンセル', '削除する']
      )
      if (!this.$_clickedConfirmOK(buttonIndex)) {
        return
      }

      const data = await this.$store.dispatch('MessageList/removeSelected', {
        ids: this.selectedIds.filter(elem => elem)
      })
      if (data.error) {
        this.$_alert('メッセージ削除に失敗')
        console.error(data)
      }
      this.selectedIds = []
      this.toggleEditMode()
      this.onRefresh()
    },

    /**
     * 全てのメッセージを削除
     */
    async handleAllRemoveClick() {
      const buttonIndex = await this.$_confirm('全てのメッセージを削除しますか？', '', [
        'キャンセル',
        '全て削除する'
      ])
      if (!this.$_clickedConfirmOK(buttonIndex)) {
        return
      }

      const data = await this.$store.dispatch('MessageList/allDelete')
      if (data.error) {
        this.$_alert('全てのメッセージ削除に失敗')
        console.error(data)
      }
      this.selectedIds = []
      this.toggleEditMode()
      this.onRefresh()
    },

    /**
     * 無限スクロール
     */
    async handleInfinite(this: any) {
      if (this.isLoading || !this.enabledInfinite) {
        return
      }
      this.isLoading = true
      await this.infinite({
        fetchPayload: this.fetchPayload
      })
      this.isLoading = false
    },

    /**
     * refresh
     */
    async onRefresh(this: any) {
      this.refreshing = true
      this.fetchPayload.params['p'] = null
      await this.fetchData()
      if (this.$refs.banner) {
        await this.$refs.banner['fetchData']()
      }
      await this.$nextTick()
      this.refreshing = false
    }
  }
})
